<template>
	<div>
		<v-btn
			block
			color="warning"
			text
			:disabled="disabled"
			class="mb-2"
			small
			@click="handleClick"
		>
			Validar telefono
		</v-btn>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'PhoneConfirmButton',
	props: {
		personId: {
			type: String,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		isPhoneVerified: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		async handleClick() {
			await this.startPhoneConfirmation(this.personId);
		},
		...mapActions({
			startPhoneConfirmation: 'Person/startPhoneConfirmation',
		}),
	},
};
</script>
